import { render, staticRenderFns } from "./ElementThumbnail.vue?vue&type=template&id=4fe0d935&scoped=true&"
import script from "./ElementThumbnail.vue?vue&type=script&lang=ts&"
export * from "./ElementThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./ElementThumbnail.vue?vue&type=style&index=0&id=4fe0d935&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe0d935",
  null
  
)

export default component.exports